import { Chip } from '@mui/material';
import { Sparkle } from '@phosphor-icons/react';
import * as React from 'react';

export const AiBadge = ({ label = 'AI' }: { label?: string }) => (
  <Chip
    icon={<Sparkle size={12} weight="fill" color="#7C3AED" />}
    label={label}
    size="small"
    sx={{
      bgcolor: '#EDE9FE',
      color: '#7C3AED',
      fontWeight: 600,
      fontSize: 10,
      height: 20,
      border: '1px solid #C4B5FD',
      '& .MuiChip-icon': { ml: '6px' },
    }}
  />
);